export default {
  allConferences: "All Conferences",
  allRegions: "All Regions",
  label: "Teams groups dropdown"
};
